<template>
  <div>
    <Main
      ref="main"
      :loading="loading"
      :tableData="tableData"
      :disabled="disabled"
      :tablePage="page"
      @reload="close()"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        :disabled="disabled"
      >
        <b-button
          size="sm"
          class="ml-2"
          variant="outline-success"
          @click="editPredictFormVisible = true"
          v-if="!disabled && allow('E')"
        >
          {{ $l('btn_editPredict') || '编辑计划' }}
        </b-button>
      </PageHeader>
    </Main>
    <EditPredictForm
      :visible="editPredictFormVisible"
      :amzFirstDemandCode="amzFirstDemandCode"
      @close="editPredictFormVisible = false"
      @reset="reload"
    />
  </div>
</template>
<script>
import Main from './main.vue'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import EditPredictForm from '../edit-predict-form'
export default {
  mixins: [BaseTable, EditLoading],
  components: { Main, PageHeader, EditPredictForm },
  props: {
    disabled: { type: Boolean, default: false },
    amzFirstDemandCode: { type: String, default: '' },
    isVcList: { type: Array, default: () => [] },
  },
  data() {
    return {
      usePage: false,
      loading: false,
      editPredictFormVisible: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData(form) {
      if (!this.amzFirstDemandCode) return
      this.loading = true
      const res = await this.$api
        .ecomAmzFirstDemandPredictListApi({
          amzFirstDemandCode: this.amzFirstDemandCode,
          ...form,
        })
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.setData(res)
    },

    close() {
      this.chooseAmzSpuVisible = false
      this.chooseAmzSkuVisible = false
      this.getData()
      this.$emit('reset')
    },

    validate() {
      return this.$refs.main.validate()
    },
    getTableData() {
      return this.$refs.main.getTableData()
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  height: 20px;
  margin-top: 3px;
}
.tag_div {
  border: 1px solid #dcdfe6;
  padding: 0px 7px 7px 7px;
  border-radius: 4px;
  min-height: 50px;
}
</style>
